import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaBlock } from './ui/CtaBlock';
import { testimonials } from '../data/content';
function initials(name: string) {
  return name.split(' ').map(part => part[0]).slice(0, 2).join('');
}
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="border-b border-arena bg-arena/40" data-id="element-141" data-mp="3ayi09lag3jqs">
      <div className="mx-auto max-w-3xl px-4 py-6 sm:py-9" data-id="element-142" data-mp="370aicn48wce0">
        <SectionHeader id="testimonios" title="Lo que dicen quienes ya empezaron" description="De no saber hacer un nudo a crear sus primeras piezas." data-id="element-143" data-mp="31zmsi4rr61ld" />
        <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-144" data-mp="2s28ba2y098s0">
          {testimonials.map((t, i) => <li key={t.author} className={`flex flex-col rounded-xl border border-arena bg-crudo p-3 ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-145" data-mp="v9yg3bmypva9" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-146" data-mp="h4dckkmqpm3n">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={13} aria-hidden="true" className="fill-terracota text-terracota" data-id="element-147" data-mp="m2opj48c0cq3" data-mpi={j} />)}
              </div>
              <blockquote className="mt-1.5 text-[0.8rem] leading-snug text-marron sm:text-sm" data-id="element-148" data-mp="c7wo1pbmp5q1">“{t.quote}”</blockquote>
              <div className="mt-auto flex items-center gap-2.5 pt-2.5" data-id="element-149" data-mp="zwy1jqzbj726">
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-olive text-xs font-extrabold text-crudo" data-id="element-150" data-mp="14uhf0oo6zft2">
                  {initials(t.author)}
                </span>
                <div className="min-w-0" data-id="element-151" data-mp="v4ep4xcdahyy">
                  <p className="text-sm font-extrabold text-marron" data-id="element-152" data-mp="v3d2dvlzo71e">{t.author}</p>
                  <p className="text-xs leading-tight text-marron/70" data-id="element-153" data-mp="1itz9nko65nac">{t.meta}</p>
                </div>
              </div>
            </li>)}
        </ul>
        <CtaBlock data-id="element-154" data-mp="1xgxyd7vn63ld" />
      </div>
    </section>;
}